{
  "version": 1,
  "assets": {
    "angleBack": {
      "path": "/game/ui/gauge/angleBack.png",
      "width": 104,
      "height": 104,
      "symbol": "asset.game.angle.back",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 109,
      "sha256": "89b4836b36387cd1cbc3ba77ea2e9a53319e681517a8c9a58efaf9ba29698bf7",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009",
      "style": {
        "x": 27.0,
        "y": 24.0,
        "width": 104.0,
        "height": 104.0,
        "smoothing": true
      }
    },
    "angleDial": {
      "path": "/game/ui/gauge/angleDial.png",
      "width": 88,
      "height": 88,
      "symbol": "asset.game.angle.dail",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 83,
      "sha256": "fd82d61a3bae175c07101eb293dfcb92ce235c5e6d737d7c4c173968bfbed145",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009",
      "style": {
        "x": 34.0,
        "y": 32.0,
        "width": 88.0,
        "height": 88.0,
        "smoothing": true
      }
    },
    "angleCircle": {
      "path": "/game/ui/gauge/angleCircle.png",
      "width": 89,
      "height": 91,
      "symbol": "asset.game.circleAsset",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 88,
      "sha256": "676957206aae15002c5a2c04781685933eb61cf212da824c9510552752ca042c",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009",
      "style": {
        "x": -46.0,
        "y": -46.0,
        "width": 89.0,
        "height": 91.0,
        "smoothing": true
      }
    },
    "angleGreen": {
      "path": "/game/ui/gauge/angleGreen.png",
      "width": 89,
      "height": 91,
      "symbol": "asset.game.greenAsset",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 77,
      "sha256": "676957206aae15002c5a2c04781685933eb61cf212da824c9510552752ca042c",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009",
      "style": {
        "x": -46.0,
        "y": -46.0,
        "width": 89.0,
        "height": 91.0,
        "smoothing": true
      }
    },
    "angleHalfRound": {
      "path": "/game/ui/gauge/angleHalfRound.png",
      "width": 98,
      "height": 98,
      "symbol": "asset.game.angle.halfround",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 76,
      "sha256": "06f3c932d14d0334fcdc6e7f2d8d57bc6552dac6922b547fd5c1bf78a95c9583",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009",
      "style": {
        "x": -49.0,
        "y": -48.0,
        "width": 98.0,
        "height": 98.0,
        "smoothing": true
      }
    },
    "angleClone": {
      "path": "/game/ui/gauge/angleClone.png",
      "width": 51,
      "height": 4,
      "symbol": "asset.game.arrowCloneAsset",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 112,
      "sha256": "ec911b48af4e9a6733ffcd337800198e67b4d32a3afab5e5f885c7bd0a1fa903",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009",
      "style": {
        "x": 0.0,
        "y": 0.0,
        "width": 44.0,
        "height": 2.0,
        "smoothing": true
      }
    },
    "angleNeedle": {
      "path": "/game/ui/gauge/angleNeedle.png",
      "width": 51,
      "height": 4,
      "symbol": "asset.game.handAsset",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 75,
      "sha256": "edfa4ac034458eb9e2bb58723bc65fc9d789e2a17353887da5a08981c07665d7",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009",
      "style": {
        "x": 0.0,
        "y": 0.0,
        "width": 44.0,
        "height": 2.0,
        "smoothing": true
      }
    },
    "angleOverlap": {
      "path": "/game/ui/gauge/angleOverlap.png",
      "width": 67,
      "height": 4,
      "symbol": "asset.game.chonghexianAsset",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 89,
      "sha256": "93d6220dbfaeaa209ce1a927dc26803c00c068ab13f36edf4db6b74b5bb8768b",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009",
      "style": {
        "x": 0.0,
        "y": 1.0,
        "width": 44.0,
        "height": 3.0,
        "smoothing": true
      }
    },
    "angleCenter": {
      "path": "/game/ui/gauge/angleCenter.png",
      "width": 11,
      "height": 11,
      "symbol": "asset.game.arrowCenterAsset",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 91,
      "sha256": "c72e5208917f91301ac157a8a145fa1b78eebea95013d5d8b2680d46b3cca715",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009",
      "style": {
        "x": -5.0,
        "y": -5.0,
        "width": 11.0,
        "height": 11.0,
        "smoothing": true
      }
    },
    "danderBg": {
      "path": "/game/ui/gauge/danderBg.png",
      "width": 102,
      "height": 104,
      "symbol": "asset.game.dander.bg",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 81,
      "sha256": "6314c6e558fd778f7f61c8ebb36d4f418abfbe449c17a1473904a645764efe60",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009",
      "style": {
        "x": 0.0,
        "y": 0.0,
        "width": 102.0,
        "height": 104.0,
        "smoothing": false
      }
    },
    "danderBack": {
      "path": "/game/ui/gauge/danderBack.png",
      "width": 103,
      "height": 104,
      "symbol": "asset.game.dander.back",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 132,
      "sha256": "231933eb519b11b0b5b5aee889e7f38d92fd42deaf0d47997afc6fab46f19a7a",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009",
      "style": {
        "x": 0.0,
        "y": 0.0,
        "width": 103.0,
        "height": 104.0,
        "smoothing": false
      }
    },
    "danderPow": {
      "path": "/game/ui/gauge/danderPow.png",
      "width": 43,
      "height": 34,
      "symbol": "asset.game.dander.animate.back",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 82,
      "sha256": "72e0e9e5d82704ea9d3ee93d5e4639a2289f5653709f1da822c907686c48bbca",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009",
      "style": {
        "x": 29.0,
        "y": 35.0,
        "width": 43.0,
        "height": 34.0,
        "smoothing": false
      }
    },
    "danderReady": {
      "path": "/game/ui/gauge/danderReady/frame-00.svg",
      "frames": [
        "/game/ui/gauge/danderReady/frame-00.svg",
        "/game/ui/gauge/danderReady/frame-01.svg",
        "/game/ui/gauge/danderReady/frame-02.svg",
        "/game/ui/gauge/danderReady/frame-03.svg",
        "/game/ui/gauge/danderReady/frame-04.svg",
        "/game/ui/gauge/danderReady/frame-05.svg",
        "/game/ui/gauge/danderReady/frame-06.svg",
        "/game/ui/gauge/danderReady/frame-07.svg",
        "/game/ui/gauge/danderReady/frame-08.svg"
      ],
      "width": 119,
      "height": 119,
      "anchor": {
        "x": 39,
        "y": 39
      },
      "frameRate": 25,
      "sha256": [
        "95c736d04e96c05055fafc01288e72a1bc922e5d999b74f2e8c565b8e42a6f46",
        "6735635ffef26bb4e385654d8dda072ab7fe1dc1ab01dc79238879fc89269482",
        "8aadc15588c2f14a91ac25243491ea55e95986bffd66a445bb0475a8e666a620",
        "083d8c7ec57e8aaee1dd58ab731d3a457adf411e49b88f29df3a0b4903c23c39",
        "2e261a3e7e6621a3930f2438f598d12c7753b42f17418332d4c11511276efb6d",
        "e5271755fcea8b7bfca272297e74663e7090b7547e12b69fce3cfbfc52fef8c9",
        "fe89692caeb0a144c03de3d84d00b6d2044fe395bb6f366d2c8294318817999c",
        "6d5dff58aae6a50e6971bfbaf437e690d65933da156a29fe5f778c91130cbcf8",
        "86f56e16b415f07170d8736b6a9818e91bc96963882b920e27fe14a4305cd611"
      ],
      "sourceCharacterId": 335,
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Exact archived SWF ShapeRecord paths, fill colors, gradients, depth, MATRIX and ShowFrame order converted to SVG; no redraw or ActionScript execution",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; geometry is not independently dated to 2009",
      "symbol": "asset.game.dande.animate",
      "placement": {
        "x": 34,
        "y": 33,
        "scale": 0.8
      }
    }
  },
  "componentLayout": {
    "sourcePath": "research/source-inspection/aim-projectile-audit/game.xml",
    "sourceUrl": "https://raw.githubusercontent.com/dk-khoado/Gunny-3.0/16e24b119f96b93b34ddb148f9a035f71a234e67/inetpub/wwwroot/gunny/ui/vietnam/xml/xml/game.xml",
    "sourceSha256": "c7d24094f92789a3a5ca9c0525ffa67c0e58d003282fd411d80c9e8df1f86730",
    "sourceGitBlob": "af5c106ba0407efbb14308db6645ed6f3375a7b9",
    "confidence": "Exact pinned later original Gunny3.0 XML layout; same source symbol names. Contemporary 2009 screenshot remains layout design reference."
  },
  "angle": {
    "width": 104,
    "height": 104,
    "pivot": {
      "x": 51.0,
      "y": 51.0
    },
    "layersBackToFront": [
      {
        "asset": "angleBack",
        "x": 0.0,
        "y": 0.0,
        "width": 104.0,
        "height": 104.0
      },
      {
        "asset": "angleCircle",
        "x": 5.0,
        "y": 5.0,
        "width": 89.0,
        "height": 91.0
      },
      {
        "asset": "angleGreen",
        "x": 5.0,
        "y": 5.0,
        "width": 89.0,
        "height": 91.0,
        "initiallyVisible": false
      },
      {
        "asset": "angleHalfRound",
        "x": 2.0,
        "y": 3.0,
        "width": 98.0,
        "height": 98.0
      },
      {
        "asset": "angleClone",
        "x": 51.0,
        "y": 51.0,
        "width": 44.0,
        "height": 2.0,
        "initiallyVisible": false,
        "transformOrigin": {
          "x": 0,
          "y": 0
        }
      },
      {
        "asset": "angleNeedle",
        "x": 51.0,
        "y": 51.0,
        "width": 44.0,
        "height": 2.0,
        "transformOrigin": {
          "x": 0,
          "y": 0
        }
      },
      {
        "asset": "angleOverlap",
        "x": 51.0,
        "y": 52.0,
        "width": 44.0,
        "height": 3.0,
        "initiallyVisible": false,
        "transformOrigin": {
          "x": 0,
          "y": 0
        }
      },
      {
        "asset": "angleCenter",
        "x": 46.0,
        "y": 46.0,
        "width": 11.0,
        "height": 11.0
      },
      {
        "asset": "angleDial",
        "x": 7.0,
        "y": 8.0,
        "width": 88.0,
        "height": 88.0
      }
    ],
    "sector": {
      "appliesTo": "angleCircle",
      "radius": 55,
      "center": {
        "x": 51.0,
        "y": 52.0
      },
      "startDegrees": "weapon.minAngle",
      "sweepDegrees": "weapon.maxAngle - weapon.minAngle + 1",
      "pointFormula": "x=cx + 55*cos(a*PI/180)*face; y=cy - 55*sin(a*PI/180)",
      "maskOnly": true,
      "mirrorX": "face == -1",
      "fly": "angleGreen replaces angleCircle and uses 0..90 degrees"
    },
    "needleRotation": "face == 1 ? -angle : 180 + angle (flat playerAngle=0); transform origin is bitmap left top, not center",
    "fullSourceRotation": "360 - (gunAngle + (gunAngle < 0 ? -180 : 180) + (direction == -1 ? 0 : 180))*direction",
    "playerSlope": "ArrowSub rotates by playerAngle; displayed number is int(gunAngle - playerAngle*direction)",
    "number": {
      "x": 29,
      "y": 56,
      "width": 44,
      "height": 26,
      "font": "bold 18px Verdana",
      "align": "center"
    }
  },
  "dander": {
    "width": 104,
    "height": 104,
    "layersBackToFront": [
      {
        "asset": "danderBg",
        "x": 0,
        "y": 0
      },
      {
        "asset": "danderBack",
        "x": -1,
        "y": -1,
        "masked": true
      },
      {
        "asset": "danderPow",
        "x": 29.0,
        "y": 35.0
      },
      {
        "asset": "danderReady",
        "x": 34,
        "y": 33,
        "scale": 0.8,
        "imageLeft": 2.799999999999997,
        "imageTop": 1.7999999999999972,
        "imageWidth": 95.2,
        "imageHeight": 95.2,
        "visible": "anger >= 200 and spellKillEnabled"
      }
    ],
    "sector": {
      "appliesTo": "danderBack",
      "center": {
        "x": 52,
        "y": 52
      },
      "radius": 52,
      "startDegrees": 90,
      "endDegrees": "90 - 270 * clamp(anger/200)",
      "pointFormula": "x=52+52*cos(a*PI/180); y=52+52*sin(a*PI/180); iterate a downward from 90 to endpoint",
      "maskOnly": true,
      "tweenDurationMs": 300
    },
    "button": {
      "x": 39,
      "y": 40,
      "hitRadius": 22,
      "visual": "Transparent hit target; POW bitmap remains inside this same single circular control."
    },
    "maskCoordinates": "Source mask uses the overall dander widget coordinate system. If masking the (-1,-1) danderBack image element alone, its mask center becomes (53,53)."
  },
  "warnings": []
}
